import i18n from '@shared/services/i18n/i18n';

const KILOBYTE = 1e3;
const MEGABYTE = 1e6;
const GIGABYTE = 1e9;

export const formatFileSize = (bytes: number, fractionDigits = 2) => {
  if (bytes >= GIGABYTE) {
    const value = (bytes / GIGABYTE).toFixed(fractionDigits);
    return `${value} ${i18n.t('common.fileSizeUnits.gb')}`;
  }

  if (bytes >= MEGABYTE) {
    const value = (bytes / MEGABYTE).toFixed(fractionDigits);
    return `${value} ${i18n.t('common.fileSizeUnits.mb')}`;
  }

  if (bytes >= KILOBYTE) {
    const value = (bytes / KILOBYTE).toFixed(fractionDigits);
    return `${value} ${i18n.t('common.fileSizeUnits.kb')}`;
  }

  return `${bytes} ${i18n.t('common.fileSizeUnits.bytes')}`;
};
